import http from 'hub-http/clients/apiClient';
import { useEffect, useState } from 'react';
export const useUsers = ({
  scope
}) => {
  const [users, setUsers] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  useEffect(() => {
    if (scope) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setLoading(true);
      http.get(`permissions-skynet/v1/scopes/app/${scope}/hub-users`).then(result => {
        setUsers(result);
      }).catch(e => {
        setError(e);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [scope]);
  return {
    data: users || [],
    loading,
    error
  };
};